module.exports = __webpack_public_path__ + "static/clawfoot_raptor-326ae666ac68b2bb2fe6046f6e2789b9.png";